import {CloneReferencedProject} from './cloneReferencedProject';
import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('CloningStructure')
export class CloningStructure {

    @JsonProperty('src_quest_no',Number)
    private readonly src_quest_no:number = 0;

    @JsonProperty('dest_quest_no',Number)
    private readonly dest_quest_no:number = 0;

    @JsonProperty('optional',Boolean)
    private readonly optional:boolean = false;

   /* @JsonProperty('referenced_project',CloneReferencedProject,true)
    private readonly referencedProject:CloneReferencedProject = null;*/

    constructor(src:number,dest:number,opt:boolean,ref:CloneReferencedProject) {
        this.src_quest_no = src;
        this.dest_quest_no = dest;
        this.optional = opt;
        // this.referencedProject = ref;
    }


    getSrcQNo(): number {
        return this.src_quest_no;
    }

    getDestQNo(): number {
        return this.dest_quest_no;
    }

    getOptional(): boolean {
        return this.optional;
    }

   /* getReferencedProject(): CloneReferencedProject {
        return this.referencedProject;
    }*/
}
